import { prisma, EmailTemplate, ResourceType, ActionType } from "client";

// CREATE
export const createEmailTemplate = async (
  userId: string,
  data: EmailTemplate
) => {
  try {
    const template = await prisma.emailTemplate.create({
      data: {
        jsonTemplate: data.jsonTemplate,
        htmlTemplate: data.htmlTemplate,
        notificationTemplate: { connect: { id: data.notificationTemplateId } },
        subject: data.subject,
        language: data.language,
        replyTo: data.replyTo,
        from: data.from,
        sgTemplateId: data.sgTemplateId,
      },
    });
    return { template };
  } catch (error: any) {
    throw new Error(error);
  }
};

// READ
export const getAllEmailTemplates = async (
  userId: string
): Promise<{
  templates?: EmailTemplate[];
  error?: any;
}> => {
  try {
    const templates = await prisma.emailTemplate.findMany();
    return { templates };
  } catch (error) {
    return { error };
  }
};

export const getAllEmailTemplateDataAndNotificationTemplateData = async (
  userId: string
) => {
  try {
    const templates = await prisma.emailTemplate.findMany();
    const withNotification: any[] = [];

    for (let template of templates) {
      const notificationTemplate = await prisma.notificationTemplate.findUnique(
        {
          where: { id: template.notificationTemplateId },
        }
      );
      withNotification.push({
        ...template,
        notificationTemplate,
      });
    }

    return { templates: withNotification };
  } catch (error) {
    return { error };
  }
};

export const getEmailTemplateById = async (id?: string) => {
  if (id) {
    return await prisma.emailTemplate.findUnique({
      where: { id },
    });
  }
  return null;
};

export const getEmailTemplateBynotificationTemplateId = async (
  userId: string,
  notificationTemplateId: string
) => {
  try {
    const emailTemplate = await prisma.emailTemplate.findUnique({
      where: { notificationTemplateId },
    });
    return { emailTemplate };
  } catch (error) {
    return { error };
  }
};

export const getEmailTemplateDataAndNotificationTemplateDataById = async (
  id: string
) => {
  try {
    const emailTemplate = await prisma.emailTemplate.findUnique({
      where: { id },
    });
    const notificationTemplate = await prisma.notificationTemplate.findUnique({
      where: { id: emailTemplate?.notificationTemplateId },
    });
    return {
      emailTemplate: {
        ...emailTemplate,
        notificationTemplate,
      },
    };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateEmailTemplateById = async (
  userId: string,
  id: string,
  data: EmailTemplate
) => {
  try {
    return await prisma.emailTemplate.update({
      where: { id },
      data: {
        jsonTemplate: data.jsonTemplate,
        htmlTemplate: data.htmlTemplate,
        notificationTemplate: { connect: { id: data.notificationTemplateId } },
        subject: data.subject,
        language: data.language,

        replyTo: data.replyTo,
        from: data.from,
      },
    });
  } catch (error) {
    return { error };
  }
};

export const updateEmailTemplateByNotificationTemplateId = async (
  notificationTemplateId: string,
  data: EmailTemplate
) => {
  return await prisma.emailTemplate.update({
    where: { notificationTemplateId },
    data: {
      jsonTemplate: data.jsonTemplate,
      htmlTemplate: data.htmlTemplate,
      subject: data.subject,
      language: data.language,
      replyTo: data.replyTo,
      from: data.from,
    },
  });
};

// DELETE
export const deleteEmailTemplateById = async (userId: string, id: string) => {
  try {
    return await prisma.emailTemplate.delete({
      where: { id },
    });
  } catch (error) {
    return { error };
  }
};
